import { z } from "zod";
import { projectRoleSchema, projectSlugSchema } from "./project";

/**
 * The signed-in person, as `GET /api/v1/me` returns them. Initials are derived, never stored, and the
 * email is deliberately absent so the shell never renders it.
 */
export const currentUserSchema = z.object({
  id: z.uuid(),
  displayName: z.string().min(1),
  initials: z.string().min(1).max(3),
});
export type CurrentUser = z.infer<typeof currentUserSchema>;

/**
 * One project the caller belongs to, as `GET /api/v1/me/projects` returns it. The balance is the
 * wallet figure in credits, or null when no wallet exists yet, so the shell never shows zero for an
 * unknown amount.
 */
export const membershipProjectSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  slug: projectSlugSchema,
  role: projectRoleSchema,
  creditBalance: z.number().int().nullable(),
});
export type MembershipProject = z.infer<typeof membershipProjectSchema>;

export const membershipProjectListSchema = z.array(membershipProjectSchema);
export type MembershipProjectList = z.infer<typeof membershipProjectListSchema>;
